module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("5")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Have you all been waiting long?” I said as I sat down at the long table. “I was told the meeting was at three.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s right,” said Alvin. He had a light, chipper sort of voice, but it sounded more like habit than genuine good cheer. “The three of us have been discussing other issues. You’re right on time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I knew scanning Caryl’s face to read her mood would be useless, so I cleared my throat and looked at Alvin and Tamika, who had positioned themselves opposite her at the table as though it were an interrogation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I assume you want to hear about what happened on stage 13 yesterday?” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your version,” said Tamika, her tone lending weight to the words.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right.” I shifted in my chair. “Caryl came to the studio yesterday. I let her into the soundstage, and we went to go look down the well, or what used to be the well. As we were looking, I got kind of a strange feeling on the back of my neck and—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What kind of feeling?” Tamika asked. “And where on your neck exactly?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("“Uh—it wasn’t that specific. Just that sort of crawly feeling you get when you think you’re being watched. I turned around and saw Teo. Thought I saw him, at any rate.”")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mateo Salazar,” Tamika clarified in the laptop’s direction. I glanced at Alvin. For the Boss of the Entire Nation, he sure seemed fine with Tamika doing all the talking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” I said. “I was partnered with him during the time I—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We know,” said Tamika in a tone that suggested she had been "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("thoroughly")]), _vm._v(" briefed on the many disastrous breaches of protocol I’d racked up during those few days. “Continue.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I pointed him out to Caryl, and she said he wasn’t really there, that it was a spell. She could see it in my eyes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tamika made her little "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("hm")]), _vm._v(" noise again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I sort of freaked out, so Caryl—comforted me as best she could, and after I’d calmed down a little, Teo—the spell—just suddenly went away.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Caryl ‘comforted’ you?” said Tamika.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I found myself unnerved by this line of questioning. “She took off one of her gloves and put a hand on my face to sort of steady me.” I felt my cheeks warming.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alvin spoke quietly to Tamika. “Skin-to-skin contact has been shown to ameliorate the effects of psychic spellwork or Gate shock.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tamika was still looking at me, holding me with her keen dark eyes. “You were comfortable with this?” she asked me. Somehow I "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("knew")]), _vm._v(" she was implying that Caryl and I were lovers. My face burned even hotter, but this time not from embarrassment.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("“Caryl has never been anything but consummately professional, even when under extreme emotional duress.” The fact that ")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("I suddenly seemed to have borrowed her vocabulary probably wasn’t helping my case.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Millie,” said Caryl.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, you heard her,” I protested. “Was I comfortable with you touching me? As though you molested me or something. I had just seen a "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("ghost")]), _vm._v(" for fuck’s sake.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“Millie,”")]), _vm._v(" she said again, sternly, with just a flicker of her eyes toward the laptop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From my angle the head of the Arcadia Project was little more than an outline and was sitting so still I couldn’t tell if her connection was still functional.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry.” I slumped back in my chair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Continue,” said Tamika.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s basically it,” I said. “I saw a ghost; Caryl said it was a spell; she touched me; I felt better; it stopped.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alvin leaned forward onto his elbows; his curiosity seemed to overcome whatever policy or personality trait had kept him silent. “You’re sure there was no one else hiding in the soundstage anywhere?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Unless they were in the well,” I said. “All the clutter had been cleared out; it was just a huge, floodlit, empty room.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You didn’t search the well?” Tamika said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A sound of disbelief escaped me. “Me personally?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Either of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("hole")]), _vm._v(". A straight vertical shaft that killed the last person who tried to go down it, and that was when it had a platform you could lower, which it doesn’t anymore. So yeah, we thought it might be a good idea to call in some backup before spelunking into an interdimensional abyss.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Tamika frowned at me. She had a dire-looking frown, but I ")]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("refused to be intimidated. I was right and she was wrong, and it’s not often that I’m sure of that in a stressful situation.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is there anything else you can remember that might be at all helpful?” she asked, her tone implying that I’d thus far been anything but.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I racked my brain. After a moment I felt a little spark of eagerness as I realized that I did remember something that might be relevant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let me in,” I said. “The ghost, or whatever it was, said ‘let me in.’ I remember it because up until that point I’d been so convinced it was actually Teo, but Teo would never have said something cheesy like that. Am I right, Caryl?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Caryl nodded blandly but didn’t comment. I wished I could see Elliott; he was probably a wreck right now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alvin’s gentle voice broke the silence. “Caryl, it was an Unseelie spell I’m assuming?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” she said. “Unmistakably. A psychic enchantment, cast upon Millie and then dispelled once its purpose apparently failed. Only there was no spell caster present.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alvin stroked his goatee with the air of someone who really doesn’t want to be the guy to say the obvious thing. He was saved the task by the telepresent British woman, whose voice made itself heard, calm and deliberate, from the laptop speakers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There was one spell caster present,” said Dame Belinda.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alvin looked at the ceiling. Tamika looked directly at Caryl.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I did not cast the spell,” Caryl said to the laptop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tamika looked at Alvin, then back at Caryl, her frown deepening. “Do we have any evidence that you didn’t?” Tamika asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aside from the fact that I was there, and know that I did not, and just told you that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aside from that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m afraid not.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("Alvin leaned forward on this elbows again, looking at Caryl with an apologetic expression. “We’re trying not to talk about your history right now, but we can’t overlook the obvious just because it’s upsetting. It would make logical sense for your control to start slipping after what happened in June.”")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“It would make sense,” agreed Caryl, “but that does not make it true, and you cannot expect me to idly accept such an accusation. I have no evidence to exonerate me, nor do you have any to convict me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hate to interrupt,” I said, which wasn’t true at all, “but what reason could Caryl possibly have for tormenting me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alvin gave a slow sigh. “There are elements to the situation, Millie, that you may not be fully aware of. It’s not my place—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She knows,” said Caryl. “Most of it, anyhow. And you’re free to tell her anything else you like.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alvin looked at Caryl incredulously. “Are you sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” she said. “The cat is largely out of the bag anyhow, and the more she knows, the more helpful she will be.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right then.” Alvin leaned back in his chair and addressed me. “We normally only discuss Arcadia with people who are under contract with us, but I guess you’re—something of a special case.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So I keep hearing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Everyone else in the room looked downright funereal, but Alvin actually half smiled at that. “What exactly did Caryl tell you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She said the Unseelie Court kidnapped her when she was a baby, and she didn’t come back here until she was, I don’t know, eight or nine?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Seven,” Caryl corrected.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("“Right, and then I think she was at the Leishman Center for a couple of years until Martin taught her how to make Elliott. Then she came to the Project and sort of apprenticed under him.”")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Except he was a wizard,” Tamika said. “She’s a warlock. Do you understand the difference?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Seelie and Unseelie, basically.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But it’s more than that,” Tamika said direly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, no,” Alvin corrected her gently. “That is actually the difference, if succinctly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But that’s not what it "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("means")]), _vm._v(".” Tamika was adamant. “An Unseelie "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("fey")]), _vm._v(" crosses a line, and we can rein them in with iron.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My memory vomited forth relevant information for the second time that day. “But Caryl’s magic isn’t susceptible to iron,” I said. “Because she’s human and iron is natural to her, or something.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“More or less,” said Tamika. “So we have nothing to counter wizards and warlocks. Which is fine for wizards, since they patch up broken bones and make things pretty. But warlocks can do the same kinds of things Vivian Chandler could do, and there’s nothing in either world that can stop them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Except conscience,” I said pointedly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’ve known Caryl how long?” Tamika said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alvin touched Tamika’s forearm briefly, and she sat back in her chair, folding her arms. When Alvin spoke, I was struck again by the marked difference in their tones. Clearly they had some practice at this good-cop-bad-cop thing.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("“Caryl was put in charge of this office at the age of fifteen,” Alvin said softly. “Her whole history has been one exception to the rules after another. We try not to even allow the existence of warlocks, but her years in Arcadia changed her just as surely ")]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("as if she’d been born half-fey. She can’t be changed back.”")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought even full-blooded fey turned human if they stayed here long enough,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Adult fey and humans change, one to the other, if they get stranded in the wrong world. But baby changelings have some biological way of buffering iron and norium from each other. We’re not sure why or how it happens, but if it didn’t, there would be no mixed-blood children at all; the foreign element would be rejected immediately by the mother’s womb.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you saying Caryl’s half-fey?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She isn’t, but she was so young when she was taken to Arcadia that her body made the adaptation anyway. Past the age of about two or three, it doesn’t seem to happen. The norium in Arcadia would slowly replace any iron in her blood, and vice versa for the fey. That’s why we limit visits to a couple of weeks except in rare cases.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are changelings common?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alvin made a sort of uncomfortable scrunch-face. “There aren’t many ethical ways to create one,” he said. “But Seelie changelings, wizards, are quite useful, so we haven’t outlawed Seelie, uh, liaisons. Just the Unseelie kind. On the rare occasions Unseelie changelings are created, policy is to execute any consenting parents and foster the children in Arcadia where that sort of magic isn’t quite so catastrophic.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you made an exception for Caryl?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not me personally,” said Alvin. “For that you can thank Dame Belinda herself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked at the laptop, making out only a vague grandmotherly frame of silver hair beneath the glare of the poorly angled screen.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("“It was not a matter of benevolence,” said Dame Belinda, “but of necessity. She was an American-born citizen and a minor who had been abducted. Once she was found, the only lawful course was to return her to her parents.”")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who were more than happy,” Caryl noted, “to give me into Martin’s care once they saw what I’d become.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Martin’s plan,” said Alvin, “was to keep her here and get her whatever kind of care and training she needed until she reached majority, then install her as a liaison at the Unseelie Court.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But then Martin died,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There were no wizards available to replace him,” said Alvin, “and regional managers have always been spell casters. By then Caryl had proven herself an incredibly capable second-in-command, so despite her age we put her in charge. For four years it worked out just fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you don’t think it’s working now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alvin gave a lopsided smile and a shrug: "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("You tell me")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tamika looked at him to see if he was finished speaking, then turned to Caryl. “We’ve been monitoring the situation here since Vivian’s death. Not only has there been very little progress in the follow-up investigation, but there has been turmoil on the Arcadian side; let’s not go into the details in present company. Let’s just say Duke Skyhollow doesn’t feel safe, and I’ve convinced Alvin that it may be time to consider a change in leadership here in L.A. While I’m no spell caster, my knowledge and my track record with the Project make me a solid candidate.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you here to relieve me of my position?” said Caryl evenly.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("Alvin winced. “Let’s not go that far yet,” he said. “We still have ")]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("some investigating to do. But there is some evidence suggesting that your powers may not be fully under your control, and now that you’ve reached the age of majority, I think you should prepare yourself for the possibility that you may be relocated to Arcadia.”")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I felt a tingling shock in the center of my chest. Elliott, I was pretty sure, had just slammed into me headfirst.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eff88c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch05.vue
// module id = 84
// module chunks = 0